import $ from 'jquery';
window.$ = window.jQuery = $;
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import '@fancyapps/fancybox';
import Swiper from 'swiper/bundle';
// import AOS from 'aos';
// import gsap from 'gsap';
import "jquery-match-height/jquery.matchHeight";
// import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import Lenis from '@studio-freight/lenis'
// gsap.registerPlugin(ScrollTrigger);

import "@fortawesome/fontawesome-free/js/fontawesome.min";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/regular.min";
import "@fortawesome/fontawesome-free/js/brands.min";

// import Swiper styles
import 'swiper/swiper-bundle.css';

//App imports

import {menuMain} from "./menu";
import {sliders} from "./sliders";
import {accordions} from "./accordions";

/****************************************************************************
 * Theme scripts.
 ****************************************************************************/



window.addEventListener('load', function() {
    // AOS.refresh();
});


(function( $ ){
    'use strict';

    setTimeout( () => {
        // AOS.init({  duration: 1000 });

        menuMain.init();
        sliders.init();
        accordions.init();

        function formatProduct (product) {
            console.log(product.imageUrl);
            if (!product.id) { return product.text; }
            var $product = $(
                '<span><img src="' + product.imageUrl + '" class="img-thumbnail" style="width: 50px;height: 50px;object-fit:cover;border-radius: 8px;" /> ' + product.text + '</span>'
            );
            return $product;
        };

      if($('#products-select')[0]){
          $('#products-select').select2({
              placeholder: "e.g. City Skyline", // Add this line
              ajax: {
                  url: myLocalizedData.ajaxurl,
                  dataType: 'json',
                  delay: 250, // wait 250 milliseconds before triggering the request
                  data: function (params) {
                      return {
                          action: 'search_unsplash', // the action in your functions.php
                          query: params.term // search term
                      };
                  },
                  processResults: function (data) {
                      console.log(data.items);
                      return {
                          results: data.items
                      };
                  },
                  cache: true
              },
              minimumInputLength: 3, // require at least 3 characters before triggering a search
              templateResult: formatProduct,
              templateSelection: formatProduct
          });
      }

        $('#image_example').on('change', function() {
            // Get the file name from the input
            var fileName = $(this).val().split('\\').pop(); // To get only the file name and not the full path
            $('#file-name-display').html('');
            // Display the file name in the div
            $('#file-name-display').text(fileName);
        });


        $('#products-select').on('change', function() {
            var selectedProduct = $(this).val();
            $('#product_id').val(selectedProduct);
            // Show the spinner before AJAX request starts
            $('#spinner').show();
            $.ajax({
                url: myLocalizedData.ajaxurl,
                method: "POST",
                data: {
                    action: "customiser_load_image",
                    product_id: selectedProduct
                },
                success: function(response) {
                    console.log(response);
                    if(response.success) {
                        // If the request was successful and an image URL was returned
                        $('#imageSide').html('<img src="' + response.data + '" alt="Product Image">');
                        $('.button--primary').prop('disabled', false);
                    } else {
                        // If there's an error, display the error message
                        $('#imageSide').html('<p>' + response.data + '</p>');
                        $('.button--primary').prop('disabled', true);

                    }
                },
                complete: function() {
                    // Hide the spinner after AJAX request completes
                    $('#spinner').hide();
                },
                error: function() {
                    // This block is executed when the AJAX request fails for some reason (e.g., server issues)
                    $('#imageresult').html('<p>Error loading image. Please try again.</p>');
                }
            });
        });

        $('#custom_product_form').on('submit', function(event) {
            event.preventDefault();
            var formData = new FormData(this);

            $.ajax({
                type: 'POST',
                url: myLocalizedData.ajaxurl,
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {

                    window.location.href = "/cart";

                }
            });
        });

        $('#custom_order_form').on('change', 'input', function() {
            // Get the values
            var width = $('input[name="width"]').val();
            var height = $('input[name="height"]').val();

            // Check if both width and height have values
            if(width && height) {
                $.ajax({
                    type: 'POST',
                    url: myLocalizedData.ajaxurl, // Make sure this is localized
                    data: {
                        action: 'custom_order_calc',
                        width: width,
                        height: height,
                        material: $('select[name="material"]').val(),
                        unit: $('select[name="unit"]').val(),
                        product_id: $('input[name="product_id"]').val(),
                        qty: $('input[name="qty"]').val() // Assuming you want to send the quantity as well
                    },
                    success: function(response) {
                        console.log(response);
                        if (response.success) {
                            $('.woocommerce-Price-amount').html(`<bdi><span class="woocommerce-Price-currencySymbol">£</span>${response.data.calculated_price.toFixed(2)}</bdi>`);
                        } else {
                            alert(response.data.message);
                        }
                    }
                });
            } else {
                // Optionally, handle the case where width or height is not provided
                console.log('Please enter both width and height.');
            }
        });

        $('#custom_order_form').on('submit', function(event){
            event.preventDefault();
            var formData = new FormData(this);
            console.log(formData);
            $.ajax({
                type: 'POST',
                url: myLocalizedData.ajaxurl,
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {
                    window.location.href = "/cart";
                }
            });
        })


        $('.js-search-trigger').on('click', function(){
            $('.js-search-form').slideToggle();
        })


        $('.side-tabs .js-tab').on('click', function(e){
            e.preventDefault();
            let tab = $(this).attr('data-tab');
            console.log(tab);
            $('.side-tabs li').removeClass('active');
            $(this).parent().addClass('active');

            $('.tab-content').removeClass('active');
            $('[data-tab-parent="'+ tab +'"]').addClass('active');
        })

        const masthead = $('.masthead');
        const placeholder = $('.placeholder');
        const mastheadOffset = masthead.offset().top;  // Get the original offset of the masthead

        $(window).on('scroll', function() {
            let scrollTop = $(this).scrollTop();

            // If scrolled past the masthead
            if (scrollTop > mastheadOffset) {
                if (!masthead.hasClass('sticky')) {
                    // Show the placeholder with the same height as the masthead
                    placeholder.height(masthead.outerHeight()).show();
                }
                masthead.addClass('sticky');
            }
            // If scrolled back above the original position of the masthead
            else {
                masthead.removeClass('sticky');
                placeholder.hide();  // Hide the placeholder
            }
        });


        var body = $(document.body);
        var button = $('.js-menu-bars');
        var line = $(".js-menu-bars line");
        var scrollPosition = 0;

        button.click(function () {
            if (body.hasClass("menu-open")) {
                body.removeClass("menu-open");
            } else {
                body.addClass("menu-open");
            }
        });


    }, 400 );

    setTimeout( () => {

        // scroll.update();

    }, 2000 );

    $(window).on('scroll', function (event) {
        // AOS.refresh();
    });


} )( jQuery );

$(function(){



})

/***************
 * After theme scripts
 ***************/

// Wrap the swiper initialization in a function
function initSwiper() {
    if ($('.filters-container .facetwp-facet').length > 0) {
        var $facet = jQuery('.facetwp-facet .facetwp-checkbox').detach();
        var $swiperContainer = jQuery('<div class="swiper-container"><div class="swiper-wrapper"></div></div>');

        $facet.each(function() {
            var $slide = jQuery('<div class="swiper-slide"></div>');
            $slide.append(jQuery(this));
            $swiperContainer.find('.swiper-wrapper').append($slide);
        });
        var $swiperButtonNext = jQuery('<div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-a677665f8b7c102e6"><svg class="icon-arrow-right" xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71"><g id="Group_171" data-name="Group 171" transform="translate(-1822 -5326)"><circle id="Ellipse_24" data-name="Ellipse 24" cx="35.5" cy="35.5" r="35.5" transform="translate(1822 5326)" fill="#61cfcc"></circle><path id="iconmonstr-arrow-25" d="M5,2.457,7.5,0l9.781,9.827L7.5,19.654,5,17.2l7.37-7.37Z" transform="translate(1846.358 5351.673)" fill="#fff"></path></g></svg></div>');

        jQuery('.facetwp-facet').append($swiperContainer);
        jQuery('.facetwp-facet').append($swiperButtonNext);

        var swiperR = new Swiper('.filters-container .swiper-container', {
            slidesPerView: 1.5,
            spaceBetween: 30,
            navigation: {
                nextEl: '.swiper-button-next',
                // If you have a previous button, add it here:
                // prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 480px
                480: {
                    slidesPerView: 1.5,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 6,
                },
                // when window width is >= 1024px
                1600: {
                    slidesPerView: 8.5,
                }
            }
        });
    }
}

// Initialize Swiper on page load
initSwiper();

// Re-initialize Swiper after FacetWP refreshes its content
jQuery(document).on('facetwp-loaded', function() {
    initSwiper();
});

// // Each time the window updates, refresh ScrollTrigger and then update LocomotiveScroll
// ScrollTrigger.addEventListener( 'refresh', () => scroll.update() );
//
// // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
// ScrollTrigger.refresh();